import React from 'react'
import { valOrFn } from 'loankeeper-common/helpers'
import { TabSliderItem } from 'loankeeper-common/components'

class TabSliderItemWrapper extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { active: wasActive, isTabSliderFocused: wasTabSliderFocused } = this.props
    const { active, isTabSliderFocused } = nextProps
    return wasActive !== active || wasTabSliderFocused !== isTabSliderFocused
  }

  handleClick = () => {
    this.props.handleSelect(this.props.index)
  }

  render() {
    const { data, active, isTabSliderFocused, isAccountEnabled } = this.props

    const isVisible = ['accounts', 'entries', 'reports'].indexOf(data.name) !== -1 ? isAccountEnabled : true

    if (!isVisible) {
      return null
    }

    return (
      <TabSliderItem
        title={valOrFn(data.title)}
        icon={data.icon}
        onClick={this.handleClick}
        isActive={active}
        isFocused={isTabSliderFocused}
      />
    )
  }
}

export default TabSliderItemWrapper
